/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React from 'react'
import DashboardIcon from '@material-ui/icons/DashboardOutlined'
import PeopleIcon from '@material-ui/icons/People';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PostAddIcon from '@material-ui/icons/PostAdd';
import BookmarksIcon from '@material-ui/icons/Bookmarks';
import ArchiveIcon from '@material-ui/icons/Archive';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import StarsIcon from '@material-ui/icons/Stars';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import ListAltIcon from '@material-ui/icons/ListAlt';
import InputIcon from '@material-ui/icons/Input'
import LockIcon from '@material-ui/icons/Lock';
import SubtitlesIcon from '@material-ui/icons/Subtitles';
import SchoolIcon from '@material-ui/icons/School';
import SecurityIcon from '@material-ui/icons/Security';
import BeenhereIcon from '@material-ui/icons/Beenhere';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';


export default [
  {
    items: [
      {
        title: "الملف الشخصي",
        href: '/profile',
        icon: AssignmentIndIcon
      },
    ],
  },
  {
    subheader: "الخبرات و المؤهلات",
    items:
      [
        // {
        //   title: "الملف الشخصي",
        //   href: '/lawyer/profile',
        // },
        {
          title: "الخبرات",
          href: '/lawyer/experiences',
          icon: SubtitlesIcon
        },
        {
          title: "المؤهلات الدراسية",
          href: '/lawyer/qualifications',
          icon: SchoolIcon
        },
        {
          title: "الدورات التدريبية",
          href: '/lawyer/courses',
          icon: LibraryBooksIcon
        },
        {
          title: "رخص مزاولة المهنة",
          href: '/lawyer/licenses',
          icon: BeenhereIcon

        },
        {
          title: "العضويات",
          href: '/lawyer/memberships',
          icon: RecentActorsIcon

        },
      ]
  },
  {
    subheader: "الدعوات و الطلبات",
    items: [
      {
        title: "الدعوات",
        href: '/invitations',
        icon: BookmarksIcon
      },
      {
        title: "العروض المقدمة",
        href: '/lawyerorders/offer',
        icon: LocalOfferIcon
      },
      {
        title: "طلباتي",
        href: '/lawyerorders',
        icon: PostAddIcon,
        items:
          [
            {
              title: "استشارة قانونية",
              href: '/lawyerorders/advice'
            },
            {
              title: "خدمات قانونية",
              href: '/lawyerorders/issue'
            },
          ]
      },
      {
        title: "الأرشيف",
        href: '/archive',
        icon: ArchiveIcon
      },
      {
        title: "التقييمات",
        href: '/lawyer/rate',
        icon: StarsIcon,
      },
    ]
  },
  {
    subheader: "حسابي",
    items: [
      {
        title: "الدفعات",
        href: '/lawyerbalance',
        icon: MonetizationOnIcon
      },
      // {
      //   title: "تغيير كلمة المرور",
      //   href: '/lawyer/account',
      //   icon: SecurityIcon
      // },
    ],
  },
  {
    items: [
      {
        title: "تغيير كلمة المرور",
        href: '/lawyer/change-password',
        icon: LockIcon
      },
      {
        title: "تسجيل الخروج",
        href: '/auth/login',
        icon: InputIcon
      },
    ],
  },
]
